<template>
    <div class="screen">
        <div class="modal animated fadeIn">
            <button class="btn-close" @click="closeForm">
                <i class="fa fa-times"></i>
            </button>
            <div class="modal-content">
                <div class="image-content">
                    <img src="imgs_send/img1.jpg" v-if="imageNo === 1">
                    <img src="imgs_send/img2.jpg" v-else-if="imageNo === 2">
                    <img src="imgs_send/img3.jpg" v-else-if="imageNo === 3">
                    <img src="imgs_send/img4.jpg" v-else-if="imageNo === 4">
                    <img src="imgs_send/img5.jpg" v-else-if="imageNo === 5">
                    <img src="imgs_send/img6.jpg" v-else-if="imageNo === 6">
                    <img src="imgs_send/img7.jpg" v-else-if="imageNo === 7">
                    <img src="imgs_send/img8.jpg" v-else-if="imageNo === 8">
                    <img src="imgs_send/img9.jpg" v-else-if="imageNo === 9">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "img-preview-component",
        props: {
            imageNo: {
                type: Number,
                required: true
            }
        },
        methods: {
            closeForm() {
                this.$emit('close')
            },
        }
    };
</script>

<style lang="sass" scoped>
    .screen
        top: 0
        left: 0
        right: 0
        bottom: 0
        position: fixed
        z-index: 9999
        background-color: rgba(0, 0, 0, .6)
        .modal
            background-color: aliceblue
            position: fixed
            top: 50%
            left: 50%
            overflow-y: auto
            transform: translate(-50%, -50%)
            border-radius: 10px
            box-sizing: border-box
            max-width: 90%
            max-height: 90%
            min-width: 350px
            min-height: 240px
            .btn-close
                background-color: #ff3f46
                color: white
                position: absolute
                top: 5px
                right: 5px
                padding: 5px 9px
                border: none
                text-align: center
                border-radius: 3em
                font-size: 1.2em
                cursor: pointer
                z-index: 1
            .modal-content
                height: 100%
                width: 100%
                overflow: hidden
                .image-content
                    height: 100%
                    width: 100%
                    img
                        max-height: 100%
                        height: auto
                        max-width: 100%
                        width: 100%
</style>
